import WipWireframeTemplatePage from './WipWireframeTemplatePage.jsx';
import WipBuySellsPage from './WipBuySellsPage.jsx';
import WipDetailPaneWireframePage from './WipDetailPaneWireframePage.jsx';
import WipAppsheetAccountsBrowserPage from './WipAppsheetAccountsBrowserPage.jsx';
import WipHomeLandingPage from './WipHomeLandingPage.jsx';

export const wipPages = [
  {
    path: '__wip/home-landing',
    title: 'Home Landing (WIP)',
    description: 'Concept landing page for GMER home navigation and workflow launch.',
    component: WipHomeLandingPage,
  },
  {
    path: '__wip/appsheet-accounts-browser',
    title: 'AppSheet Accounts Browser',
    description: 'Browse SF_GM Salesforce Accounts with fuzzy search, full column controls, and detail drawer tabs.',
    component: WipAppsheetAccountsBrowserPage,
  },
  {
    path: '__wip/detailpane-wireframe',
    title: 'Detail Pane Wireframe',
    description: 'Slimmed status cards and summary layout for detail pane iteration.',
    component: WipDetailPaneWireframePage,
  },
  {
    path: '__wip/buy-sells',
    title: 'Buy/Sells Dashboard',
    description: 'Buy/sell workflow dashboard with stages, DAF upload, and alert actions.',
    component: WipBuySellsPage,
  },
  {
    path: '__wip/wireframe-template',
    title: 'Wireframe Template',
    description: 'Starter layout with mock sections and data placeholders.',
    component: WipWireframeTemplatePage,
  },
];
